import { ReportFinancesDataWriteOffSummary } from 'app/dataTypes/reports/data/common/financesSummaryWriteOff'

import { convertResultFinancesSummaryReplenishment } from './finances-summary-replenisment'
import { ApiResultFinancesSummaryReplenishment } from './finances-summary-replenisment'

export type ApiResultFinancesSummaryWriteOff = ApiResultFinancesSummaryReplenishment

export const convertResultFinancesSummaryWriteOff = (
  res: ApiResultFinancesSummaryWriteOff,
): ReportFinancesDataWriteOffSummary => convertResultFinancesSummaryReplenishment(res)
